export default function kebabCase(str) {
    return str && str.replace ?
        str.replace(/([a-z])([A-Z])/g, '$1-$2')
            .replace(/\s+/g, '-')
            .replace(/_/g, '-')
            .toLowerCase() : null;
}
